import { Dispatch, memo, SetStateAction, useState } from "react";
import { useHistory } from "react-router-dom";
import { CardBox } from "../../../../../components/Card";
import IconButton from "../../../../../components/IconButton";
import useAppData from "../../../../../hook/useAppData";
import { IconPencilRevert, IconTrash } from "../../../../../icons";
import { renderName } from "../../../../../libs/getInitialLetters";
import { ACCESS } from "../../../../Profile/constants";
import { IListProjects } from "../../../model";

type ICardProjects = {
  projects: IListProjects[];
  setNeedModalDelete: Dispatch<SetStateAction<{ status: boolean; id: number | string }>>;
};

function CardProjects({ projects, setNeedModalDelete }: ICardProjects) {
  const history = useHistory();
  const { accessIds } = useAppData();
  const [options, setOptions] = useState<{ status: boolean; id: number }>();
  function redirect(id) {
    history.push(`projects/details/${id}`);
  }

  return (
    <>
      {projects?.map((project) => {
        return (
          <>
            <CardBox
              key={project?.id}
              name={project?.name}
              img={project?.img}
              more={options?.status && options?.id === project?.id && accessIds.includes(ACCESS.PROJECT_write) ? true : false}
              onMouseEnter={() => setOptions({ status: true, id: project?.id })}
              onMouseLeave={() => setOptions(undefined)}
              childrenHeader={
                <>
                  <IconButton
                    icon={IconPencilRevert}
                    onClick={() => history.push(`projects/form/${project?.id}`)}
                    className="text-primary duration-300 hover:ease-in filter hover:bg-gray-300 rounded-xl"
                  />
                  {!project.is_deleted && (
                    <IconButton
                      icon={IconTrash}
                      onClick={() => setNeedModalDelete({ status: true, id: project?.id })}
                      className="text-secondary duration-300 hover:ease-in filter hover:bg-gray-300 rounded-xl"
                    />
                  )}
                </>
              }
              onClick={() => {
                redirect(project?.id);
              }}
              classNameChildren="pl-4 pt-2 gap-2"
            >
              <div className={`flex font-familyPoppins ${project?.status ? "items-center" : "items-end"}`}>
                <span className="text-1.4rem font-bold text-textPrimary">Status:</span>
                <span
                  className={`max-w-max ml-2 rounded-lg font-semibold text-textPrimary ${project?.status ? "text-lg" : "text-1.4rem"} ${
                    (project.status === "Ativo" && "bg-green-100 text-green-600 p-1") ||
                    (project.status === "Cancelado" && "bg-red-100 text-red-600 p-1") ||
                    (project.status === "Concluído" && "bg-gray-200 text-gray-600 p-1")
                  }`}
                >
                  {project?.status || "Não informado"}
                </span>
              </div>

              <hr className="-ml-4 border-b-2 bg-background" />

              <div className=" text-1.4rem font-bold text-textPrimary font-familyPoppins">
                Projeto:
                <h6 className="pl-2 text-2xl font-semibold limit-10-char"> {project?.name}</h6>
              </div>

              <hr className="-ml-4 border-b-2 bg-background" />

              <div className=" text-1.4rem font-bold text-textPrimary font-familyPoppins">
                {project?.clientName ? "Cliente:" : "Responsável:"}
                <h6 className="pl-2 text-2xl font-semibold limit-10-char"> {project?.clientName || project?.projectManager}</h6>
              </div>
            </CardBox>
          </>
        );
      })}
      ;
    </>
  );
}

export default memo(CardProjects);
